var __jsx = React.createElement;
import React from "react";
var OtpIcon = function OtpIcon(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? "#E1EBFD" : _ref$bgColor,
    _ref$primaryColor = _ref.primaryColor,
    primaryColor = _ref$primaryColor === void 0 ? "#154f9c" : _ref$primaryColor;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: "97",
    height: "82",
    viewBox: "0 0 97 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    opacity: "0.4",
    d: "M96.2439 33.3968V47.9778C96.2439 72.2794 86.6195 82 62.5585 82H33.6854C9.62439 82 0 72.2794 0 47.9778V33.3968C0 12.9929 6.78519 2.88732 23.1948 0.144366H24.061L72.1829 0C89.2181 2.50234 96.2439 12.6561 96.2439 33.3968Z",
    fill: bgColor
  }), /*#__PURE__*/React.createElement("g", {
    id: "history"
  }, /*#__PURE__*/React.createElement("g", {
    id: "smartphone (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55 53.25H41C39.0706 53.25 37.5 51.6803 37.5 49.75V37.5C37.5 35.5697 39.0706 34 41 34H55C56.9294 34 58.5 35.5697 58.5 37.5V49.75C58.5 51.6803 56.9294 53.25 55 53.25ZM41 37.5V49.75H55.0017L55 37.5H41Z",
    fill: primaryColor
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M53.25 37.5H42.75C41.7828 37.5 41 36.7163 41 35.75V32.25C41 28.3902 44.1393 25.25 48 25.25C51.8607 25.25 55 28.3902 55 32.25V35.75C55 36.7163 54.2172 37.5 53.25 37.5ZM44.5 34H51.5V32.25C51.5 30.3197 49.9294 28.75 48 28.75C46.0706 28.75 44.5 30.3197 44.5 32.25V34Z",
    fill: primaryColor
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M62 69H34C31.105 69 28.75 66.645 28.75 63.75V18.25C28.75 15.355 31.105 13 34 13H62C64.895 13 67.25 15.355 67.25 18.25V63.75C67.25 66.645 64.895 69 62 69ZM34 16.5C33.0343 16.5 32.25 17.2852 32.25 18.25V63.75C32.25 64.7148 33.0343 65.5 34 65.5H62C62.9656 65.5 63.75 64.7148 63.75 63.75V18.25C63.75 17.2852 62.9656 16.5 62 16.5H34Z",
    fill: primaryColor
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M53.25 20H42.75C40.8206 20 39.25 18.4303 39.25 16.5V14.75C39.25 13.7836 40.0328 13 41 13H55C55.9672 13 56.75 13.7836 56.75 14.75V16.5C56.75 18.4303 55.1794 20 53.25 20Z",
    fill: primaryColor
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M51.5 62H44.5C43.5328 62 42.75 61.2164 42.75 60.25C42.75 59.2836 43.5328 58.5 44.5 58.5H51.5C52.4672 58.5 53.25 59.2836 53.25 60.25C53.25 61.2164 52.4672 62 51.5 62Z",
    fill: primaryColor
  })))));
};
export default OtpIcon;